export enum BIEventType {

    DepositBtnClick = "Deposit Btn Click",
    TradeBtnClick = "Trade Btn Click",
    BannerBtnClick = "Banner Btn Click",
    DeepLinkOpenPosition = "Deep link open position",
    SymbolSelected = "Symbol Selection",
    SearchbarUsedModal = "Searchbar used (modal)",
    SearchbarUsed = "Searchbar used",
    CreateTradeModalBtnClick = "Create a Trade Btn Click",
    SetAlertModalBtnClick = "Set alert modal Btn Click",
    AddSymbolToWatchlist = "Add Symbol to watchlist",
    RemoveSymbolFromWatchlist = "Remove Symbol from watchlist",
    BuyBtnBOPopupClick = "Buy btn BO popup click",
    SellBtnBOPopupClick = "Sell btn BO popup click",
    BuyBtnSymbolRowClick = "Buy btn Symbol row click",
    SellBtnSymbolRowClick = "Sell btn Symbol row click",
    BuyBtnChartClick = "Buy btn Chart click",
    SellBtnChartClick = "Sell btn Chart click",
    SymbolRowDoubleClick = "Symbol row double click",
    OpenSymbolSidebar = "Open Symbol sidebar for new order",
    CloseSymbolSidebar = "Close Symbol sidebar for new order",
    SidebarTabChecked = "Sidebar Tab checked ",
    PositionDirection = "Position direction selection",
    PositionAmount = "Position amount changed",
    OrderTypeSelection = "Order type selection",
    OrderRateValue = "Order rate value",
    StopLossAdded = "Stop Loss Added",
    TakeProfitAdded = "Take Profit Added",
    StopLossRemoved = "Stop Loss Removed",
    TakeProfitRemoved = "Take Profit Removed",
    PositionPromotion = "Position promotion selection",
    PositionExpiration = "Position expiration changed",
    ExpirationDateRemoved = "Expiration date removed",
    PositionOpening = "Position try to open",
    PositionOpened = "Position opened",
    PositionFailed = "Position failed to open",
    CreateTradeBtnClick = "Create Trade btn click",
    UpdateTradeBtnClick = "Update Trade btn click",
    CloseTradeBtnClick = "Close Trade btn click",
    CancelCloseTradeBtnClick = "Cancel Close Trade click",
    ConfirmDeleteTradeBtnClick = "Confirm Delete Trade btn click",
    CreateOrderBtnClick = "Create Order btn click",
    UpdateOrderBtnClick = "Update Order btn click",
    DeleteOrderBtnClick = "Delete Order btn click",
    CancelDeleteOrderBtnClick = "Cancel Delete Order click",
    ConfirmDeleteOrderBtnClick = "Confirm Delete Order btn click",
    WithdrawalAmount = "Withdrawal amount",
    WithdrawalReason = "Withdrawal reason",
    FeedbackComment = "Feedback comment",
    TradeSelected = "Trade selected",
    TradeRowDoubleClick = "Trade row double click",
    EditTradeRowBtnClick = "Edit trade row btn click",
    CloseTradeRowBtnClick = "Close trade row btn click",
    EditOrderRowBtnClick = "Edit order row btn click",
    CloseOrderRowBtnClick = "Close order row btn click",
    AddStopLossRowBtnClick = "Add stop loss row btn click",
    AddTakeProfitRowBtnClick = "Add take profit row btn click",
    MoveStopLossOnChart = "Move Stop Loss on chart",
    MoveTakeProfitOnChart = "Move Take Profit on chart",
    EditBtnChartClick = "Edit btn Chart click",
    CloseBtnChartClick = "Close btn Chart click",
    HeaderBackBtnClick = "Header Back btn click",
    SettingsBtnClick = "Settings btn click",
    CloseFilterSidebar = "Close filter sidebar",
    AlwaysShowChartEnabled = "Always show chart enabled",
    AlwaysShowChartDisabled = "Always show chart disabled",
    ClearSidebarSettings = "Clear sidebar settings",
    SGDisclaimerBtnClick = "SG Disclaimer btn click",
    SGSignalSelectSidebar = "SG Signal Select (Sidebar)",
    SGViewAllClickSidebar = "SG View all click (Sidebar)",
    SGCopyToTradeBtn = "SG Copy to Trade Btn",
    SGTableTabClick = "SG Table Tab click",
    SGAddToWatchlist = "SG Add to watchlist",
    SGRemoveFromWatchlist = "SG Remove from watchlist",
    SGTableSingleClick = "SG Table single click",
    SGTableDoubleClick = "SG Table double click",
    SGTableBuyBtnClick = "SG Table Buy btn click",
    SGTableSellBtnClick = "SG Table Sell btn click",
    SGSettingBtnClick = "SG Setting btn click",
    SGClearAllSetting = "SG Clear all Setting",
    SGSettingType = "SG Setting Type",
    SGSettingPatternType = "SG Setting Pattern Type",
    SGSettingProbability = "SG Setting Probability",
    SGSettingProbabilityOnly = "SG Setting Probability Only",
    SGSettingAdded = "SG Setting Added",
    SGSettingInterval = "SG Setting Interval",
    SGSettingTarget = "SG Setting Target",
    SGSettingApplyBtnClick = "SG Setting Apply btn click",
    CloseSettingsSidebar = "Close Settings sidebar",
    SGSignalsListFromSymbols = "SG Signals list from symbols",
    SGSettingPatternName = "SG Setting Pattern Name",
}
